module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"copy":"copiar","copied":"copiado"},"en-US":{"copy":"copy","copied":"copied"}}')
  delete Component.options._Ctor
}
